export function buildSummaryPayments(donor) {
    if (!donor?.id || !donor.pledges)
        return [];
    return donor.pledges
        .flatMap(pledge => (pledge.applications || []).map((application) => {
        const payment = application.payment || {};
        return {
            id: `${payment.id}-${pledge.id}`,
            type: 'Payment',
            pledgeId: pledge.id,
            amount: application.amount,
            date: payment.date,
            paymentType: payment.type,
            referrer: payment.referrer || null,
            donor: payment.donor?.name || '',
            department: pledge.department || null,
            campaignId: pledge.campaign?.id || null,
            campaign: pledge.campaign?.name || '',
            subcampaignId: pledge.subCampaign?.id || null,
            subcampaign: pledge.subCampaign?.name || '',
            householdID: donor.id
        };
    }))
        .filter(payment => payment.id && payment.date)
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
}
export function formatPaymentType(type) {
    if (!type)
        return '';
    if (type === type.toUpperCase())
        return type;
    return type.replace(/([a-z])([A-Z])/g, '$1 $2');
}
export function formatReferrerLabel(referrer) {
    try {
        const url = new URL(referrer);
        return `${url.host}${url.pathname === '/' ? '' : url.pathname}`;
    }
    catch {
        return referrer.length > 60 ? `${referrer.slice(0, 57)}...` : referrer;
    }
}
export function getReferrerUtms(referrer) {
    try {
        const url = new URL(referrer);
        const utms = [];
        url.searchParams.forEach((value, key) => {
            if (key.toLowerCase().startsWith('utm_') && value) {
                utms.push(`${key.slice(4)}=${value}`);
            }
        });
        return utms;
    }
    catch {
        return [];
    }
}
export function formatReferrerUtmLabel(referrer) {
    const utms = getReferrerUtms(referrer);
    return utms.length ? `UTM: ${utms.join(', ')}` : '';
}
